import { render, staticRenderFns } from "./BlockPalette.vue?vue&type=template&id=44ef7cd6&scoped=true&"
import script from "./BlockPalette.vue?vue&type=script&lang=js&"
export * from "./BlockPalette.vue?vue&type=script&lang=js&"
import style0 from "./BlockPalette.vue?vue&type=style&index=0&id=44ef7cd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ef7cd6",
  null
  
)

export default component.exports